export default "__VITE_ASSET__wcBYsXIr__"